(ns ui.editors.entity-creator.utils
  (:require
   [common.localization :as loc]
   [common.schema.entities.pipeline :as pipeline]
   [common.schema.entity-type-names :as entity-type-names]
   [common.util :as cu]))

(defn inherited-mandatory?
  [stages-config stages stage]
  (let [stage-ord (:common/ord stage)
        before (->> stages
                    (filter (fn [{:keys [common/ord]}]
                              (< ord stage-ord))))]
    (->> before
         (some (fn [{:keys [db/id]}]
                 (= (get stages-config id)
                    :mandatory))))))

(defn set-and-inherit!
  [{:keys [state stages stage new-setting]}]
  (let [{:keys [db/id]} stage
        stage-ord (:common/ord stage)
        after (->> stages
                   (filter (fn [{:keys [common/ord]}]
                             (< stage-ord ord)))
                   (map (fn [{:keys [db/id]}]
                          [id new-setting]))
                   (into {}))
        stages-settings (assoc after id new-setting)]
    (swap! state update :stages merge stages-settings)))

;; config: field-config or association-config;
;; modifieds {:setting visibility-setting} to just visibility-setting
(defn simplified-visibility
  [config visibility-key]
  (if (= visibility-key :stages)
    (->> (get config visibility-key)
         (mapv (fn [[k v]]
                 [k (:setting v)]))
         (into {})
         (assoc {} visibility-key))
    (update config :create :setting)))

(defn association-label
  [{:keys [only-entity-type?]} other-et association-type]
  (if only-entity-type?
    (loc/tr association-type)
    (loc/tr :creator-config/entity-association-label
            [(entity-type-names/get-name other-et :en)
             (loc/tr association-type)])))

(defn association-key-label
  [{:keys [only-entity-type?]} [other-et _person-et association-type :as _association-key]]
  (if only-entity-type?
    (loc/tr association-type)
    (loc/tr :creator-config/entity-association-label
            [(entity-type-names/get-name other-et :en)
             (loc/tr association-type)])))

(defn overview-association-key-label
  [[other-et _person-et association-type :as _a-key]]
  (loc/tr :creator-config/overview-entity-association-label
          [(if (pipeline/pipeline-entity? other-et)
             (loc/tr :creator/opportunity)
             (entity-type-names/get-name other-et :en))
           (cu/smart-lower-case (loc/tr association-type))]))
